<template>
  <base-nav class="navbar-top navbar-dark"  id="navbar-main" :show-toggle-button="false" expand>
    <router-link class="navbar-brand" :to="isShippop()">
      <img src="/img/brand/logo.png" class="navbar-brand-img max-navbar-logo" />
      <span class="small mb-0 ml-1 align-bottom version-text">V {{popVersion}}</span>
    </router-link>
    <ul class="navbar-nav align-items-center d-none d-md-flex justify-content-end w-100">
      <DropDownWallet />
      <div class="pl-4 pr-2">
        <NotificationBell :dataNotify="dataNotify" :paginate="paginate" :isload="isload" :newMessage="newMessage"
        :setNewMessage="setNewMessage"/>
      </div>
      <!-- <div class="pl-4 pr-2">
        <i class="fas fa-th"></i>
      </div> -->
      <li class="nav-item dropdown">
        <DropDownShop />
      </li>
    </ul>

    <VerifyWalletModal ref="verifyWalletModal" />
  </base-nav>
</template>
<script>
import { getCookie } from "@/helpers/util"
import NotificationBell from "@/components/NotificationPlugin/NotificationBell"
import DropDownShop from "@/components/custom/DropDownShop"
import DropDownWallet from "@/components/custom/DropDownWallet"
import VerifyWalletModal from '@/components/Wallet/VerifyWalletModal'

export default {
  components:{
    NotificationBell,
    DropDownShop,
    DropDownWallet,
    VerifyWalletModal
  },
  data() {
    return {
      popVersion: process.env.VUE_APP_VERSION,
      activeNotifications: false,
      newMessage: false,
      showMenu: false,
      dataNotify:[],
      isload: false,
      paginate:{
        page: 1,
        totalPage: 0,
      },
      searchQuery: "",
      userLogin: "",
    };
  },
  mounted(){
    this.userLogin = JSON.parse(localStorage.getItem('user'))
    this.getNotify()

    this.$refs.verifyWalletModal.openModal()
  },
  methods: {
    setNewMessage( status ){
      this.newMessage = status
    },
    async getNotify(){
      this.isload = true
      await this.$http.get( this.$API_URL + '/notify', {
        headers : {
           Token: localStorage.getItem("access_token")
        },
        params: {
          page: this.paginate.page
        }
      }).then( res => {

        let data = res.data.data
        this.dataNotify = [ ...this.dataNotify , ...data.data]

        if( this.dataNotify.length &&
          (
            !getCookie('read_noti') ||
            (this.moment(this.dataNotify[0].created_at).valueOf() > getCookie('read_noti'))
          )
        ){

          this.setNewMessage( true )

        }else{

          this.setNewMessage( false )

        }
        this.paginate.page = data.page
        this.paginate.totalPage = data.total_page

      })
      this.isload = false

    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    isShippop(){
      let part = '/'
      if( this.userLogin.role === 'shippop' ){
        part = ''
      }
      return part
    }
  },
  watch: {
    '$route' (to, from) {
      if(from.name == 'usershop'){
        this.userLogin = JSON.parse(localStorage.getItem('user'))
      }

      this.$refs.verifyWalletModal.openModal()
    },
    'paginate.page' ( old , current ){
      this.getNotify()
    }
  },
};
</script>
<style lang="scss" scoped>

    #navbar-main{

      z-index: 101;

    }
    .word-break {
      white-space: normal;
      word-break: break-word;
    }
    #new-message{

      font-size: 10px;

    }
  .notify-admin{

    #btn-notify{

      color:whitesmoke;
    }

    &:hover{
      cursor: pointer
    }
    #btn-notify:active{
      color:#f5f5f59c;
    }
  }
  .version-text {
    font-size: 1rem;
  }
</style>
